export const SOCKET_USERS = {
    CHANGE_USER_STATUS: 'change_user_state',
    USER_EDIT_PROFILE: 'user_edit_profile',
    ADMIN_CHANGE_EMAIL: 'admin_change_email',
    USER_LEAVE_TEAM: 'user_leave_team'
}